import axios from '@/libs/axios'

const serializeParams = params => {
  const searchParams = new URLSearchParams()
  Object.keys(params || {}).forEach(key => {
    const value = params[key]
    if (value === null || value === undefined) {
      return
    }
    if (Array.isArray(value)) {
      value.forEach(item => {
        if (item !== null && item !== undefined) {
          searchParams.append(`${key}[]`, item)
        }
      })
    } else {
      searchParams.append(key, value)
    }
  })
  return searchParams.toString()
}

export default {
  getOrders: (query = {}) => axios.get('/order/find', {
    params: query,
    paramsSerializer: params => serializeParams(params),
  }),
  getOrderPlanner: (query = {}) => axios.get('/order/planner', {
    params: query,
    paramsSerializer: params => serializeParams(params),
  }),
  getOrderById: id => axios.get(`/order/${id}`),
  identifyOrderByNumber: number => axios.get(`/order/find-by-number/${number}`),
  addOrder: data => axios.post('/order', data),
  cloneOrder: id => axios.post(`/order/${id}/clone`),
  addOrderComment: (id, data) => axios.post(`/order/${id}/comment/add`, data),
  updateOrder: (id, data) => axios.put(`/order/${id}`, data),
  patchOrder: (id, data) => axios.patch(`/order/${id}`, data),
  upsertOrderPlanning: (id, data) => axios.put(`/order/${id}/planning`, data),
  deleteOrderPlanning: id => axios.delete(`/order/${id}/planning`),
  getOrderWorkflow: id => axios.get(`/order/${id}/workflow`),
  changeOrderStatusAction: (id, data) => axios.post(`/order/${id}/actions/change-status`, data),
  assignOrderTeamAction: (id, data) => axios.post(`/order/${id}/actions/assign-team`, data),
  transferOrderTeamAction: (id, data) => axios.post(`/order/${id}/actions/transfer-team`, data),
  releaseOrderTeamAction: (id, data) => axios.post(`/order/${id}/actions/release-team`, data),
  createOrderPatientData: (orderId, data) => axios.post(`/order/${orderId}/patient-info`, data),
  updateOrderPatientData: (id, data) => axios.patch(`/order/patient-info/${id}`, data),
  fetchTransportHistory: data => axios.post('/order/transport-history', data),
  manualRouteSort: (id, patientInfoIds) => axios.post(`/order/${id}/manual-route-sort`, {
    patientInfoIds,
  }),
  deleteOrder: id => axios.delete(`/order/${id}`),
  getDiseases: query => axios.get(`/order/diseases-classification/${query}`),
  getSummaryByOrderId: id => axios.get(`/order/summary/by-order/${id}`),
  updateSummary: (id, data) => axios.put(`/order/summary/${id}`, data),
  requestOrderSummaryRecalculation: orderId => axios.get(`/order/summary/calculate/${orderId}`),
  requestOrderSummaryRecalculationForMonth: payload => axios.get(`/order/summary/calculate/month/${payload.month}${payload.customerId ? `/${payload.customerId}` : ''}`),
}
